import PriceSliderFilter from './PriceSliderFilter';

export default PriceSliderFilter;
